import { render, staticRenderFns } from "./BuscadorOperacionCrud.vue?vue&type=template&id=0cb2f49f&"
import script from "./BuscadorOperacionCrud.vue?vue&type=script&lang=ts&"
export * from "./BuscadorOperacionCrud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0cb2f49f', component.options)
    } else {
      api.reload('0cb2f49f', component.options)
    }
    module.hot.accept("./BuscadorOperacionCrud.vue?vue&type=template&id=0cb2f49f&", function () {
      api.rerender('0cb2f49f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/BuscadorOperacionCrud.vue"
export default component.exports